/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import {
    Inject,
    Injector,
    Component,
    ViewChild,
    forwardRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { progress } from "@progress/jsdo-core";
import { SupplierDataDetailsViewBaseComponent } from "./supplier-data-details.view.base.component";
import { IntlService } from "@progress/kendo-angular-intl";
import { SortDescriptor, orderBy } from "@progress/kendo-data-query";
import { TimeoutManagerService } from "../../../shared/services/timeout-manager.service";
import { CustomAuthorizationService } from "../../../core/auth/custom-authorization.service";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { DJIVGroupBookingDetailTableComponent } from "../../../shared/components/djiv-tables/djiv-group-booking-detail-table/djiv-group-booking-detail-table.component";

const ServiceTypes = require("../../../shared/components/djiv-tables/service-types.json");
const DEFAULT_SERVICE_ICON = "fa-address-book-o";

@Component({
    templateUrl: "./supplier-data-details.view.component.extended.html",
    styleUrls: ["./supplier-data-details.view.component.css"],
})
export class SupplierDataDetailsViewComponent extends SupplierDataDetailsViewBaseComponent {
    @ViewChild(forwardRef(() => DJIVGroupBookingDetailTableComponent))
    groupBookingTable: DJIVGroupBookingDetailTableComponent;

    public sortChanges: SortDescriptor[] = [
        { field: "ChangeDate", dir: "desc" },
    ];
    public description: any;
    public prefixDescription: any;

    public ttGroupBooking: any;
    public ttGroupBookingChanges: any;
    public ttGroupBookingChangeReasons: any;
    public ttGroupBookingDetailAcco: any;
    public ttGroupBookingDetailVerv: any;
    public ttGroupBookingDetailOdns: any;
    public ttGroupBookingContact: any;
    public ttGroupBookingLuggageLabel: any;
    public driversList: any[];
    public driverSaveMode: boolean = false;
    public driversDropdownLabel = " Choose driver...";

    public groupBookingDetailAccoByUnitType: any;
    public groupBookingDetailOdnsByUnitType: any;
    public groupBookingDetailVervByUnitType: any;

    public ttGroupBookingUnit: any;
    public groupBookingUnitTotal: any;

    public ttGroupBookingBoard: any;

    public duration: number;
    public durationUnit: string;

    protected jsdo: progress.data.JSDO;
    protected isLoading: boolean = true;
    protected BookingInfo: any;

    private timeoutManagerService: TimeoutManagerService;
    private router: Router;
    private session: progress.data.JSDO;

    private ProductCode: string;
    private ServiceType: string;
    private ServiceCode: string;
    private SegmentBeginDate: string;

    public isPrinting: Boolean = false;

    private dsGroupBookingDetail: any;
    constructor(
        @Inject(Injector) injector: Injector,
        @Inject(ActivatedRoute) protected route: ActivatedRoute,
        @Inject(IntlService) protected intl: IntlService,
        @Inject(CustomAuthorizationService)
        protected customAuthorizationService: CustomAuthorizationService,
        @Inject(DomSanitizer) protected domSanitizer: DomSanitizer,
        @Inject(Location) private location: Location,
        private http: HttpClient
    ) {
        super(injector);
        this.timeoutManagerService = injector.get(TimeoutManagerService);
        this.router = injector.get(Router);
        this.initData();
        this.readData();
    }

    // Fired when component is initialized and input properties are set
    public onInit(): void {
        // this.initHeaderPanel();
    }

    // Fired when component's views and child views are initialized
    public onShow(): void {}
    // Fired just before Angular destroys the component. Unsubscribe Observables and detach event handlers to avoid memory leaks
    public onHide(): void {}

    private initData() {
        this.route.queryParams.forEach((params) => {
            this.ProductCode = params["ProductCode"];
            this.ServiceType = params["ServiceType"];
            this.ServiceCode = params["ServiceCode"];
            this.SegmentBeginDate = params["SegmentBeginDate"];
        });
        this.BookingInfo = {};
        this.session = new progress.data.JSDO(
            "GroupBookingDetailBusinessEntity"
        );
        this.session.subscribe("afterFill", (jsdo, success, response) => {
            this.jsdo = jsdo;

            if (success) {
                const dsGroupBookingDetail = Object.assign(
                    {},
                    response.response.dsGroupBookingDetail
                );
                this.dsGroupBookingDetail = dsGroupBookingDetail;
                if (this.isGroupBookingEmpty(dsGroupBookingDetail)) {
                    this.router.navigate(["group-booking/supplier-data"]);
                    return;
                }

                if (dsGroupBookingDetail.ttGroupBooking)
                    this.ttGroupBooking = dsGroupBookingDetail.ttGroupBooking;

                if (dsGroupBookingDetail.ttGroupBookingUnit)
                    this.ttGroupBookingUnit =
                        dsGroupBookingDetail.ttGroupBookingUnit.sort(
                            (unit, nextUnit) =>
                                unit.UnitDescription.localeCompare(
                                    nextUnit.UnitDescription
                                )
                        );

                if (dsGroupBookingDetail.ttGroupBookingBoard)
                    this.ttGroupBookingBoard =
                        dsGroupBookingDetail.ttGroupBookingBoard;

                if (dsGroupBookingDetail.ttGroupBookingChanges)
                    this.ttGroupBookingChanges =
                        dsGroupBookingDetail.ttGroupBookingChanges;

                if (dsGroupBookingDetail.ttGroupBookingChangeReasons)
                    this.ttGroupBookingChangeReasons =
                        dsGroupBookingDetail.ttGroupBookingChangeReasons;

                if (dsGroupBookingDetail.ttGroupBookingDetailAcco)
                    this.ttGroupBookingDetailAcco =
                        dsGroupBookingDetail.ttGroupBookingDetailAcco;

                if (dsGroupBookingDetail.ttGroupBookingDetailOdns)
                    this.ttGroupBookingDetailOdns =
                        dsGroupBookingDetail.ttGroupBookingDetailOdns;

                if (dsGroupBookingDetail.ttGroupBookingDetailVerv)
                    this.ttGroupBookingDetailVerv =
                        dsGroupBookingDetail.ttGroupBookingDetailVerv;

                if (dsGroupBookingDetail.ttGroupBookingContact)
                    this.ttGroupBookingContact =
                        dsGroupBookingDetail.ttGroupBookingContact[0];
                if (dsGroupBookingDetail.ttSupplierDriver)
                    this.driversList = dsGroupBookingDetail.ttSupplierDriver
                        .map((driver) => driver.DriverName)
                        .sort();

                Object.assign(this.BookingInfo, this.ttGroupBooking[0]);

                if (!this.BookingInfo.Driver1) {
                    this.BookingInfo.Driver1 = this.driversDropdownLabel;
                }

                this.handleGroupBooking();
                this.handleGroupBookingUnit();
                this.handleGroupBookingBoard();
                this.handleGroupBookingChanges();
                this.handleGroupBookingDetailVerv();
                this.handleGroupBookingDetailAcco();
                this.handleGroupBookingDetailOdns();
                this.getLuggageLabels();
            } else if (response.response.status_code === 401) {
                this.timeoutManagerService.handleTimeout();
            }

            Promise.all([
                this.customAuthorizationService.processAuthorizationResponse(),
            ]).then(() => {
                this.isLoading = false;
            });
        });
    }

    protected readData() {
        this.isLoading = true;
        return this.session.fill({
            filter: JSON.stringify(this.filterData()),
        });
    }

    private isGroupBookingEmpty(dsGroupBookingDetail: any): boolean {
        return (
            !dsGroupBookingDetail ||
            (this.isArrayNullOrEmpty(dsGroupBookingDetail.ttGroupBooking) &&
                this.isArrayNullOrEmpty(
                    dsGroupBookingDetail.ttGroupBookingChanges
                ) &&
                this.isArrayNullOrEmpty(
                    dsGroupBookingDetail.ttGroupBookingDetailAcco
                ) &&
                this.isArrayNullOrEmpty(
                    dsGroupBookingDetail.ttGroupBookingDetailVerv
                ) &&
                this.isArrayNullOrEmpty(
                    dsGroupBookingDetail.ttGroupBookingDetailOdns
                ))
        );
    }

    private isArrayNullOrEmpty(array: any[]): boolean {
        return array === null || array === undefined || array.length === 0;
    }

    private handleGroupBookingChanges() {
        if (!this.ttGroupBookingChanges) return;

        this.ttGroupBookingChanges.forEach((change) => {
            change.ChangeDate = new Date(change.ChangeDate);
            if (change.ConfirmationDate != null) {
                change.ConfirmationDate = new Date(change.ConfirmationDate);
            }
        });
        this.ttGroupBookingChanges = {
            data: orderBy(this.ttGroupBookingChanges, this.sortChanges),
            total: this.ttGroupBookingChanges.length,
        };
    }

    private splitDetailByUnitDescription(ttGroupBookingDetail): any {
        if (!this.ttGroupBookingUnit)
            return [
                {
                    UnitDescription: "All",
                    DetailRows: ttGroupBookingDetail,
                },
            ];

        let splitArray = [];
        let lastUnitNr;

        this.ttGroupBookingUnit.forEach((unitType) => {
            lastUnitNr = undefined;
            splitArray.push({
                UnitDescription: unitType.UnitDescription,
                DetailRows: ttGroupBookingDetail
                    .filter(
                        (detailRow) =>
                            detailRow.UnitDescription ===
                            unitType.UnitDescription
                    )
                    .sort((a, b) => {
                        if (a.UnitNr < b.UnitNr) return -1;

                        if (a.UnitNr > b.UnitNr) return 1;

                        if (a.UnitNr === b.UnitNr) {
                            if (a.GuestName < b.GuestName) return -1;

                            if (a.GuestName > b.GuestName) return 1;

                            if (a.GuestName === b.GuestName) return 0;
                        }
                    })
                    .map((a, i, arr) => {
                        //add i/arr to check if it's the last check we do; we could probably move lastUnitNr = undefined to line 181/182
                        if (lastUnitNr !== a.UnitNr) {
                            lastUnitNr = a.UnitNr;
                            return a;
                        } else {
                            let copy = { ...a };
                            copy.UnitNr = undefined;
                            return copy;
                        }

                        // if (arr.length - 1 === i) {
                        //     lastUnitNr = undefined;
                        // }
                    }),
            });
        });

        return splitArray;
    }
    private handleGroupBookingDetailVerv() {
        if (!this.ttGroupBookingDetailVerv) return;

        this.groupBookingDetailVervByUnitType =
            this.splitDetailByUnitDescription(this.ttGroupBookingDetailVerv);
    }

    private handleGroupBookingDetailAcco() {
        if (!this.ttGroupBookingDetailAcco) return;

        this.groupBookingDetailAccoByUnitType =
            this.splitDetailByUnitDescription(this.ttGroupBookingDetailAcco);
    }

    private handleGroupBookingDetailOdns() {
        if (!this.ttGroupBookingDetailOdns) return;

        this.groupBookingDetailOdnsByUnitType =
            this.splitDetailByUnitDescription(this.ttGroupBookingDetailOdns);
    }

    private handleGroupBooking() {
        if (!this.ttGroupBooking) return;

        this.ttGroupBooking = this.ttGroupBooking[0];

        if (this.ttGroupBooking.ServiceType === "EX")
            this.durationUnit = "Days";
        else this.durationUnit = "Nights";

        let endTimestamp: number = new Date(
            this.ttGroupBooking.SegmentEndDate
        ).valueOf();
        let startTimestamp: number = new Date(
            this.ttGroupBooking.SegmentBeginDate
        ).valueOf();

        this.duration = (endTimestamp - startTimestamp) / 86400000;
    }

    private handleGroupBookingUnit() {
        if (!this.ttGroupBookingUnit) return;

        let totalUnits: number = 0;
        let totalGuests: number = 0;
        let includeAllotment: boolean = false;

        this.ttGroupBookingUnit.forEach((unitType) => {
            totalUnits += unitType.NumUnits;
            totalGuests += unitType.NumGuests;
            if (unitType.ReleaseDate != null) {
                includeAllotment = true;
            }
        });

        this.groupBookingUnitTotal = {
            NumUnits: totalUnits,
            NumGuests: totalGuests,
            IncludeAllotment: includeAllotment,
        };
    }

    private handleGroupBookingBoard() {
        if (!this.ttGroupBookingBoard) return;

        this.ttGroupBookingBoard = this.ttGroupBookingBoard.filter(
            (boardType) =>
                boardType.BoardType && boardType.BoardType.trim() !== ""
        );
    }

    private kendoFilterData() {
        return [
            {
                field: "ProductCode",
                operator: "eq",
                value: this.ProductCode,
            },
            {
                field: "ServiceType",
                operator: "eq",
                value: this.ServiceType,
            },
            {
                field: "ServiceCode",
                operator: "eq",
                value: this.ServiceCode,
            },
            {
                field: "SegmentBeginDate",
                operator: "eq",
                value: this.SegmentBeginDate,
            },
        ];
    }

    private filterData() {
        return {
            dsFilter: {
                ttFilter: this.kendoFilterData(),
            },
        };
    }

    public printBooking() {
        this.isPrinting = false;
        setTimeout(function () {
            window.print();
        }, 500);
    }

    public backButton() {
        this.location.back();
    }

    public getSafeHtmlChanges(changes: string) {
        return this.domSanitizer.bypassSecurityTrustHtml(changes);
    }

    public getChangeReasons(GroupBookingChangesId) {
        return this.ttGroupBookingChangeReasons.filter(
            (el) => el.GroupBookingChangesId === GroupBookingChangesId
        );
    }

    public getGroupBookingStatusIconClass(): string {
        switch (this.ttGroupBooking.GroupBookingStatus) {
            case "Guaranteed":
                return "coloured fa fa-check";

            case "Planned":
                return "coloured fa fa-tasks";

            case "Cancelled":
                return "coloured fa fa-ban";

            default:
                return "coloured fa fa-question";
        }
    }

    public getIconClass(): string {
        if (this.ttGroupBooking.ServiceType === "EX")
            return ServiceTypes[this.ttGroupBooking.ServiceType][
                this.ttGroupBooking.ServiceType
            ].icon;
        return ServiceTypes[this.ttGroupBooking.ServiceType]
            ? ServiceTypes[this.ttGroupBooking.ServiceType].icon
            : DEFAULT_SERVICE_ICON;
    }

    public async confirmBooking(externalBookRef) {
        try {
            this.jsdo["ttGroupBooking"].foreach((element) => {
                element.assign({
                    ExternalGroupBookID: externalBookRef,
                });
            });

            this.isLoading = true;
            await this.jsdo.saveChanges(true);
            await this.readData();
        } catch (e) {
            this.isLoading = false;
            if (e.request.response.status_code === 401) {
                this.timeoutManagerService.handleTimeout();
            }
        }
    }

    public getLuggageLabels() {
        const currentFilter = JSON.stringify(this.filterData());
        const jsdo = new progress.data.JSDO("GroupBookingDetailBusinessEntity");
        jsdo.invoke("ReadGroupBookingLuggageLabel", {
            filter: currentFilter,
        }).then(
            (response) => {
                this.ttGroupBookingLuggageLabel =
                    response.request.response[
                        "dsGroupBookingLuggageLabel"
                    ].dsGroupBookingLuggageLabel.ttGroupBookingLuggageLabel;
            },
            (errorResponse) => {
                console.log(errorResponse);
            }
        );
    }

    public printLabels(): void {
        this.isPrinting = true;
        setTimeout(function () {
            window.print();
            this.isPrinting = false;
        }, 500);
    }

    public approveRequest(item: any): void {
        const jsdo = new progress.data.JSDO("GroupBookingDetailBusinessEntity");

        this.isLoading = true;
        jsdo.invoke("OnRequestApproval", {
            BookID: item.BookID,
            SegmentID: item.SegmentID,
            BookingStatus: item.BookingStatus,
            ExternalGroupBookingID: this.ttGroupBooking.ExternalGroupBookID,
        }).then(
            () => {
                this.groupBookingTable.closeDialog();
                this.readData();
            },
            (errorResponse) => {
                alert(errorResponse);
                this.isLoading = false;
            }
        );
    }

    public declineRequest(item: any): void {
        const jsdo = new progress.data.JSDO("GroupBookingDetailBusinessEntity");

        this.isLoading = true;
        jsdo.invoke("OnRequestDecline", {
            BookID: item.BookID,
            DeclineComment: item.BookingComment,
            SegmentID: item.SegmentID,
            BookingStatus: item.BookingStatus,
        }).then(
            () => {
                this.groupBookingTable.closeDialog();
                this.readData();
            },
            (errorResponse) => {
                alert(errorResponse);
                this.isLoading = false;
            }
        );
    }

    public groupRowsByUnit(detailRows: any[]): any[] {
        let currentUnitNr = null;
        const groups: any[] = [];

        detailRows.forEach((row: any) => {
            if (row.UnitNr !== undefined && row.UnitNr !== null) {
                currentUnitNr = row.UnitNr;
            } else {
                row.UnitNr = currentUnitNr;
            }

            let group = groups.find((x) => x.UnitNr === row.UnitNr);

            if (!group) {
                group = {
                    UnitNr: row.UnitNr,
                    BookingStatus: row.BookingStatus,
                    BookID: row.BookID,
                    UnitDescription: row.UnitDescription,
                    Guests: [],
                };

                groups.push(group);
            }

            group.Guests.push(row);
        });

        return groups;
    }

    public onDriverChange(): void {
        if (this.BookingInfo.Driver1) {
            this.driverSaveMode = true;
        }
    }

    public submitDrivers(): void {
        const url = `${
            environment.getDataProviders()["SupplierAppProvider"].serviceUri
        }/web/pdo/SupplierAppService/GroupBookingDetailBusinessEntity/SubmitDriver`;
        this.http
            .put(
                url,
                {
                    dsGroupBookingDetail: {
                        ...this.dsGroupBookingDetail,
                        ttGroupBooking: [this.BookingInfo],
                    },
                },
                { withCredentials: true }
            )
            .subscribe(async () => {
                this.driverSaveMode = false;
                await this.readData();
            });
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/group-booking/supplier-data-details/supplier-data-details.view.component.ts